var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.46094V1.64062C0 1.25098 0.286607 0.9375 0.642857 0.9375H3.64286L3.89464 0.389648C4.00179 0.149414 4.22411 0 4.46786 0H7.52946C7.77321 0 7.99554 0.149414 8.10536 0.389648L8.35714 0.9375H11.3571C11.7134 0.9375 12 1.25098 12 1.64062V2.46094C12 2.6543 11.8554 2.8125 11.6786 2.8125H0.321429C0.144643 2.8125 0 2.6543 0 2.46094ZM11.1214 4.12207L10.575 13.6816C10.5321 14.4229 9.96964 15 9.29196 15H2.70804C2.03036 15 1.46786 14.4229 1.425 13.6816L0.878571 4.12207C0.867857 3.91992 1.01518 3.75 1.2 3.75H10.8027C10.9848 3.75 11.1321 3.91992 11.1214 4.12207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.dda47dc94868596b297f7bd1b1fcda71.svg";
export { ForwardRef as ReactComponent };